import React from 'react';
import { useIntl } from '@atlassian/jira-intl';
import commonMessages from '../../common/messages.tsx';
import { PlaceholderSpacer, ReadViewContainer } from '../../common/ui/styled.tsx';
import { type Status, StatusLozenge } from './status-lozenge/index.tsx';

type Props = {
	status: Status | null;
};

export const StatusReadView = ({ status }: Props) => {
	const { formatMessage } = useIntl();
	const placeholderText = formatMessage(commonMessages.placeholderNoneSelected);

	return (
		<ReadViewContainer isPlaceholder={!status}>
			<PlaceholderSpacer>
				{status !== null ? (
					<StatusLozenge ellipsis isEditable={false} status={status} />
				) : (
					placeholderText
				)}
			</PlaceholderSpacer>
		</ReadViewContainer>
	);
};
